import { render, staticRenderFns } from "./CMSPage.vue?vue&type=template&id=604d0de7"
import script from "./CMSPage.vue?vue&type=script&lang=js"
export * from "./CMSPage.vue?vue&type=script&lang=js"
import style0 from "./CMSPage.vue?vue&type=style&index=0&id=604d0de7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports